/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{DisposableProgram as r}from"./Program.js";function e(e,t,n,o=""){return new r(e,o+t.vertexShader,o+t.fragmentShader,n)}export{e as createProgram};
